import packageJson from '../../../package.json'

export function AppVersion() {
  return (
    <span className="text-sm text-muted-foreground ml-2">
      {packageJson.version}
    </span>
  )
}
